import { sidebarExtra, connections, formData, tabsItem, fields } from '../structure'
import { mapState } from 'vuex'
import firebase from 'firebase'

export const itemMixins = {
	data() {
		return {
			idPage: null,
			validForm: true,
			dataForm: null,
		}
	},
	computed: {
		tabsItem() {
			return tabsItem
		},
		fields() {		
			return fields
		},
		...mapState(['tabs'])
	},
	methods: {
		saveAction() {
			if (this.$refs.formUser.validateForm() == true) {
				this.$store.commit('setLoading', true)
				if (this.idPage === 'new'){
					// TODO: registrar correo al crear un nuevo usuario
					
					this.$connector.post(connections.constType, {url: connections.typeUrl, data: this.dataForm})
					.then((docRef) => {
							this.$router.push({name: this.$route.name, params: { id: docRef.id }, query: { created: true }})
							if (this.$route.query.created) {
								this.$store.commit('setActiveSnackbar', true)
							}
							this.$store.commit('setLoading', false)
					})
					.catch((error) => {
							console.error("Error adding document: ", error);
					});
				} else {
					
					this.$connector.put(connections.constType, {url: connections.typeUrl, id: this.idPage, data: this.dataForm})
					.then(() => {
							this.$store.commit('setActiveSnackbar', true)
							this.$store.commit('setLoading', false)
					})
					.catch((error) => {
							console.error("Error adding document: ", error);
					});
				}
			} else {
				
				// Hacer control de errores - Que marque donde esta el error, en que pestaña
			}
		},
		setUniversal() {
			if (this.$refs.formUser.validateForm() == true) {
				this.$store.commit('setLoading', true)
				
				this.$connector.put(connections.constType, {url: connections.typeUrl, id: this.idPage, data: {"uuid": "*"}  })
				.then(() => {
						this.$store.commit('setActiveSnackbar', true)
						this.$store.commit('setLoading', false)
						
						this.$router.go()
				})
				.catch((error) => {
						console.error("Error adding document: ", error);
				});
				
			} else {
				
				// Hacer control de errores - Que marque donde esta el error, en que pestaña
			}
		},
		removeUniversal() {
			if (this.$refs.formUser.validateForm() == true) {
				this.$store.commit('setLoading', true)
				
				this.$connector.put(connections.constType, {url: connections.typeUrl, id: this.idPage, data: {uuid: firebase.firestore.FieldValue.delete()}  })
				.then(() => {
						this.$store.commit('setActiveSnackbar', true)
						this.$store.commit('setLoading', false)
						
						this.$router.go()
				})
				.catch((error) => {
						console.error("Error adding document: ", error);
				});
				
			} else {
				
				// Hacer control de errores - Que marque donde esta el error, en que pestaña
			}
		}
	},
	created() {
		this.$store.commit('setLoading', true)
		// Arreglar datos por defecto
		const idPage = this.$route.params.id
		this.idPage = idPage
		
		// setear toolbar
		var toolbarOpt = {
			title: this.titlePage,
			path: this.$route.fullPath,
			actions: [
				{icon: 'security', action: this.setUniversal, class: 'green'}
			]
		}
		
		

		// Setear datos
		if (idPage !== 'new') {
			this.$connector.get(connections.constType, {url: connections.typeUrl, id: idPage})
			.then(doc => {
				if(doc.exists) {
					var data = doc.data()
					this.titlePage,	toolbarOpt.title = 'Editar ' + data.nombre
					this.dataForm = data					
					
					
					if( data.uuid != "*" ){
						toolbarOpt.actions = [{icon: 'security', action: this.setUniversal, class: 'red'}]
					}else{
						toolbarOpt.actions = [{icon: 'star', action: this.removeUniversal, class: 'green'}]
					}
					
					this.$store.commit('toolbarOptions', toolbarOpt)
					
				}
				this.$store.commit('setLoading', false)
			})
		} else {
			this.dataForm = formData.clean()
			this.dataForm = formData.data
			
			this.$store.commit('toolbarOptions', toolbarOpt)
			this.$store.commit('setLoading', false)
		}
		
			

		// Setear toolbar
		if (this.$route.meta.extraSidebar === true)
			this.$store.commit('setExtraSidebar', {compSidebar: sidebarExtra.item})

		// crear tabs "hacerlo con un dispatch"
		var tabs = {
			activeTab: '',
			items: []
		}
		tabsItem.map((e) => {
			if (e.active) {
				tabs.activeTab = 'tab-' + e.name
			}
			tabs.items.push(e.name)
		})

		// setear tabs
		this.$store.commit('setTabs', tabs)
	}
}
